"use client"

import { motion } from "framer-motion"
import { FaUser, FaEnvelope, FaPhone, FaGoogle, FaLock } from "react-icons/fa"

const inputVariants = {
  focus: { scale: 1.02, transition: { duration: 0.2 } },
}

const BasicInfoForm = ({ formData, handleChange, handleNextStep, login, user, error }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="bg-white rounded-xl shadow-xl overflow-hidden"
    >
      <div className="bg-gradient-to-r from-[var(--navy-blue)] to-[var(--navy-blue-light)] py-4 px-6">
        <h3 className="text-white text-xl font-semibold">Información Básica</h3>
        <p className="text-blue-100 text-sm">Paso 1 de 2</p>
      </div>

      <form id="registrationForm" onSubmit={handleNextStep} className="p-6 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <motion.div variants={inputVariants} whileFocus="focus">
            <label htmlFor="username" className="block mb-1 text-sm font-medium text-gray-700">
              Nombre de Usuario
            </label>
            <div className="relative">
              <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
                required
                placeholder="Usuario"
              />
            </div>
          </motion.div>

          <motion.div variants={inputVariants} whileFocus="focus">
            <label htmlFor="email" className="block mb-1 text-sm font-medium text-gray-700">
              Correo Electrónico
            </label>
            <div className="relative">
              <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
                required
                placeholder="ejemplo@correo.com"
              />
            </div>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <motion.div variants={inputVariants} whileFocus="focus">
            <label htmlFor="name" className="block mb-1 text-sm font-medium text-gray-700">
              Nombre
            </label>
            <div className="relative">
              <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
                required
                placeholder="Nombre completo"
              />
            </div>
          </motion.div>

          <motion.div variants={inputVariants} whileFocus="focus">
            <label htmlFor="lastname" className="block mb-1 text-sm font-medium text-gray-700">
              Apellido
            </label>
            <div className="relative">
              <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                id="lastname"
                name="lastname"
                value={formData.lastname}
                onChange={handleChange}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
                required
                placeholder="Apellido"
              />
            </div>
          </motion.div>
        </div>

        <motion.div variants={inputVariants} whileFocus="focus">
          <label htmlFor="password" className="block mb-1 text-sm font-medium text-gray-700">
            Contraseña
          </label>
          <div className="relative">
            <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
              required
              placeholder="Contraseña segura"
            />
          </div>
        </motion.div>

        <motion.div variants={inputVariants} whileFocus="focus">
          <label htmlFor="phone" className="block mb-1 text-sm font-medium text-gray-700">
            Teléfono
          </label>
          <div className="relative">
            <FaPhone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="tel"
              id="phone"
              name="phone"
              pattern="+[0-9]{3}[0-9]{3}[0-9]{3}[0-9]{4}"
              value={formData.phone}
              onChange={handleChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
              required
              placeholder="+34 XXX XXX XXX"
            />
          </div>
        </motion.div>

        <div className="pt-4">
          <motion.button
            type="submit"
            className="w-full bg-gradient-to-r from-[var(--gold)] to-[var(--gold-dark)] text-white py-3 px-4 rounded-lg hover:from-[var(--gold-dark)] hover:to-[var(--gold)] transition duration-300 font-medium"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Continuar
          </motion.button>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600 mb-3">O regístrate con:</p>
          <motion.button
            type="button"
            onClick={login}
            className="w-full bg-white text-gray-700 border border-gray-300 py-3 px-4 rounded-lg hover:bg-gray-50 transition duration-300 flex items-center justify-center shadow-sm"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <FaGoogle className="mr-2 text-red-500" />
            Registrarse con Google
          </motion.button>
        </div>
      </form>
    </motion.div>
  )
}

export default BasicInfoForm

